import React from "react";
import * as XLSX from "xlsx";

const HEADERS = [
  "Product Code",
  "Category",
  "Material Sub Category",
  "Product Name",
  "HSN Code",
  "Location",
  "Quantity",
  "Unit",
  "Target Category",
  "Critical Product",
  "Brand",
  "Product Type",
  "Discarded",
  "Top Selling",
  "Warranty",
  "Mfg. By",
  "Mkt By",
  "Barcode", 
];

const SAMPLES = [
  {
    "Product Code": "CPAP-001",
    Category: "RESPIRATORY",
    "Material Sub Category": "C-PAP",
    "Product Name": "Dream Station Auto",
    "HSN Code": "90192090",
    Location: "Rent", // "Rent" or "Sale"
    Quantity: 1,
    Unit: "1",
    "Target Category": "RESPIRATORY",
    "Critical Product": "No",
    Brand: "Philips",
    "Product Type": "Rent", // "Rent" or "Sale"
    Discarded: "No",
    "Top Selling": "Yes",
    Warranty: "",
    "Mfg. By": "Medirent",
    "Mkt By": "Medirent",
    Barcode: "06$CPP06000014",
  },
  {
    "Product Code": "WAS011",
    Category: "MOBILITY",
    "Material Sub Category": "WALKING STICK",
    "Product Name": "Quadripod Premium Stick",
    "HSN Code": "90211000",
    Location: "Sale",
    Quantity: 1,
    Unit: "1",
    "Target Category": "B",
    "Critical Product": "No",
    Brand: "Medirent",
    "Product Type": "Sale",
    Discarded: "No",
    "Top Selling": "No",
    Warranty: "",
    "Mfg. By": "Medirent",
    "Mkt By": "Medirent",
    Barcode: "WAS011000123",
  },
];

const DownloadBarcodeTemplateMR = ({
  fileName = "Product_Barcode_Bulk_Upload_Template.xlsx",
}) => {
  const downloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([HEADERS]);
    XLSX.utils.sheet_add_json(ws, SAMPLES, { origin: "A2", skipHeader: true });
    ws["!cols"] = HEADERS.map(() => ({ wch: 22 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");
    XLSX.writeFile(wb, fileName);
  };

  return (
    <button className="btnTable" type="button" onClick={downloadTemplate}>
      <i className="bi bi-download px-2"></i>
      Download Template
    </button>
  );
};

export default DownloadBarcodeTemplateMR;
